import { Form } from 'antd'

import { PageBreadcrumbs } from 'src/components'
import { StockAdminIssuanceCreate } from 'src/features/stock-administration/components'
import { useLocales } from 'src/locales'

export const StockAdminIssuanceApplicationsCreate = () => {
  const [form] = Form.useForm()

  const { t } = useLocales()

  return (
    <PageBreadcrumbs
      title={`${t('stock_applications.stock_issuance_create')}`}
      items={[
        { title: t('menu.consumable_medicaments') },
        { title: t('stock.applications') }
      ]}
    >
      <Form form={form} layout="vertical">
        <StockAdminIssuanceCreate form={form} />
      </Form>
    </PageBreadcrumbs>
  )
}
